import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { DateTime } from 'luxon';

export interface CoacheesAddMeetingState {
	meetingDate: Date;
	coacheeId: string;
	modulesId: string[];
	saving: boolean;
}

@Injectable()
@StoreConfig({ name: 'ui-add-coach-meeting-dialog' })
export class AddCoachMeetingDialogStore extends Store<CoacheesAddMeetingState> {
	constructor() {
		super({
			meetingDate: DateTime.local()
				.set({ hour: 14, minute: 0 })
				.plus({ day: 1 })
				.toJSDate(),
		});
	}
}
